import React from 'react';
import './style.scss';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/tomatoes_hero.jpg';
import imgHeroMobile from './i/mobile/tomatoes_hero.jpg';
import arrow from '../../../../assets/images/hero-arrow.png';
import { TranslatableText } from '../../../../providers/LanguageProvider';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_tomato_1.jpg';
import slide2 from './i/carousel_tomato_2.jpg';
import slide3 from './i/carousel_tomato_3.jpg';
import slide4 from './i/carousel_tomato_4.jpg';
import slide5 from './i/carousel_tomato_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Tomatoes = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food-pages tomatoes">

                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="tomatoes" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="tomatoes" />
                    }
                </div>

                <div className="copy-block">
                    <h1><span><span className="line"></span><TranslatableText dictionary={{ "en": "Our", "fr": "Nos"}} ></TranslatableText><span className="line"></span></span><TranslatableText dictionary={{ "en": "Tomatoes", "fr": "Tomates"}} ></TranslatableText></h1>
                  
                    
                    {props.lang === 'en' && <p>Nothing beats a juicy beefsteak tomato, especially one that ripens on the vine. Every single one of our tomatoes is hand-picked and stored at room temperature to preserve its perfectly sweet flavour.</p>}
                    {props.lang === 'fr' && <p>Rien ne bat une belle tranche de tomate juteuse, surtout quand elle a mûri sur le plant. Chacune de nos tomates est cueillie à la main et conservée à température pièce pour préserver son petit côté sucré.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="where-block">
                            
                {props.lang !== 'fr' ?
                    <>
                        <h2>What's our&nbsp;  
                            <span>tomato story?</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>D’où vient notre&nbsp;  
                            <span>tomates?</span>
                        </h2>
                    </>
                }
            </div>

            <SliderWrap {...props}>
                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>PERFECT RECIPE</h3>
                                        <p>The recipe for growing a perfectly plump beefsteak tomato starts with the sun.</p>
                                    </>
                                :
                                    <>
                                        <h3>RECETTE PARFAITE</h3>
                                        <p>Pour faire pousser de parfaites tomates cœur de bœuf, il faut du soleil.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>FRESH YEAR-ROUND</h3>
                                        <p>Greenhouses capture the sun’s light and warmth so fresh fruit can grow 365 days a year.</p>
                                    </>
                                :
                                    <>
                                        <h3>FRAÎCHES À L’ANNÉE</h3>
                                        <p>Les serres captent les rayons et la chaleur du soleil pour que les fruits frais puissent pousser 365 jours par année.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>NATURAL PROCESS</h3>
                                        <p>Bees pollinate each plant and rain water is used for irrigation.</p>
                                    </>
                                :
                                    <>
                                        <h3>PROCESSUS NATUREL</h3>
                                        <p>Des abeilles pollinisent chaque plant et l’irrigation est faite à l’eau de pluie.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>NATURAL PROCESS</h3>
                                        <p>Bees pollinate each plant and rain water is used for irrigation.</p>
                                    </>
                                :
                                    <>
                                        <h3>CULTIVÉES SANS HERBICIDES</h3>
                                        <p>Nos tomates sont cultivées sans herbicides et, grâce à l’utilisation de bons insectes, presque sans pesticides.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>HAND-PICKED</h3>
                                        <p>Each tomato stays on the vine until it is ready to be picked by hand.</p>
                                    </>
                                :
                                    <>
                                        <h3>CUEILLIES À LA MAIN</h3>
                                        <p>Chaque tomate reste sur le plant jusqu’à ce qu’elle soit prête à être récoltée à la main.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </SliderWrap>

            <IngredientsSlider currentPage="tomatoes" {...props} />
            <MobileOrderBanner {...props} />
        </>

    )
}
export default Tomatoes;